export const missionsPanelMessages = {
  "missionsPanel.tasks": "Tasks",
  "missionsPanel.needsYou": "Needs you",
  "missionsPanel.answer": "Answer",
  "missionsPanel.needs.form": "Question from {actor}",
  "missionsPanel.needs.permission": "Permission requested by {actor}",
  "missionsPanel.action.start": "Start",
  "missionsPanel.action.pause": "Pause",
  "missionsPanel.action.resume": "Resume",
  "missionsPanel.action.runNow": "Run now",
  "missionsPanel.action.checkPassage": "Check passage",
  "missionsPanel.action.checkStatus": "Check status",
  "missionsPanel.action.stop": "Stop…",
  "missionsPanel.action.openConversation": "Open conversation",
  "missionsPanel.action.requestUpdate": "Request an update",
  "missionsPanel.action.requestUpdatePending": "Update requested…",
  "missionsPanel.action.requestUpdateUncertain": "Delivery unconfirmed",
  "missionsPanel.action.recover": "Recover interrupted mission",
  "missionsPanel.task.active": "Active",
  "missionsPanel.task.ready": "Up next",
  "missionsPanel.task.blocked": "Blocked",
  "missionsPanel.task.assigned": "Assigned",
  "missionsPanel.task.waiting": "Waiting",
  "missionsPanel.task.failed": "Failed",
  "missionsPanel.task.done": "Done",
  "missionsPanel.schedule.every": "Every day at {time}",
  "missionsPanel.schedule.nextRow": "Next: {when}",
  "missionsPanel.schedule.when": "{day} {time}",
  "missionsPanel.schedule.noRuns": "No run yet.",
  "missionsPanel.pastRuns": "Past runs",
  "missionsPanel.technical": "Technical details",
  "missionsPanel.technical.mission": "Mission ID",
  "missionsPanel.technical.coordinator": "Coordinator conversation ID",
  "missionsPanel.technical.schedule": "Schedule ID",
  "missionsPanel.schedule.zoned": "{time} ({zone})",
  "missionsPanel.state.inProgress": "In progress",
  "missionsPanel.run.completed": "Completed",
  "missionsPanel.run.failed": "Failed",
  "missionsPanel.run.stopped": "Stopped",
  "missionsPanel.run.ended-without-report": "Ended without a report",
  "missionsPanel.run.interrupted": "Interrupted by a restart",
  "missionsPanel.run.not-started": "Not started",
  "missionsPanel.reader.runOf": "Run of {when}",
  "missionsPanel.reader.resultFailed": "The result of this run couldn't be loaded.",
  "missionsPanel.reader.retry": "Retry",
  "missionsPanel.reader.part": "Part",
  "missionsPanel.technical.passage": "Run ID",
  "missionsPanel.technical.conversation": "Conversation ID",
  "missionsPanel.technical.due": "Scheduled for",
  "missionsPanel.technical.settled": "Finished",
  "missionsPanel.task.unblocks": "Unblocks: {tasks}",
  "missionsPanel.task.readout": "Coordinator note",
  "missionsPanel.overview": "Summary",
  "missionsPanel.dailyBadge": "Daily",
  "missionsPanel.task.input": "Awaiting your input",
  "missionsPanel.task.retired": "Retired",
  "missionsPanel.task.openConversation": "Open the task's conversation",
  "missionsPanel.picker.label": "Current mission",
  "missionsPanel.picker.none": "No mission selected",
  "missionsPanel.picker.expand": "Show all missions",
  "missionsPanel.picker.collapse": "Hide the mission list",
  "missionsPanel.picker.withAttention": "{action} ({attention})",
  "missionsPanel.picker.search": "Filter missions",
  "missionsPanel.picker.noMatch": "No matching mission",
  "missionsPanel.picker.edit": "Edit selected mission",
  "missionsPanel.picker.delete": "Delete selected mission…",
  "missionsPanel.picker.actions": "Mission actions",
  "missionsPanel.attention.permission.one": "{count} waiting",
  "missionsPanel.attention.permission.other": "{count} waiting",
  "missionsPanel.attention.failed.one": "{count} failed",
  "missionsPanel.attention.failed.other": "{count} failed",
  "missionsPanel.attention.working.one": "{count} running",
  "missionsPanel.attention.working.other": "{count} running",
} as const
